<section class="full-container error-mannagment">
  <div class="flex-container central-alignment-h flex-direction-column justify-content-center">
    <img class="icon" src="https://munily-public-cdn.s3.amazonaws.com/general/modal-icons/warning-modal-icon.png" alt="warning-icon">
    <h5 *ngIf="errorTitleMessage" class="txt-c m-3 h5_500">{{errorTitleMessage | translate}}</h5>
    <p *ngIf="(errorMessage && errorsList.length === 0)" class="subtitle-1 text-center">{{errorMessage | translate}}</p>
    <ng-template *ngIf="errorsList.length > 0">
      <p class="subtitle-1 text-center m-0">{{"faceRecognition.errors.errorsDetected" | translate}}</p>
      <div class="errors-section mt-4 mb-4">
        <ul class="errors-list">
          <li *ngFor="let error of errorsList; let i = index" class="body-2">
            <span class="alert-icon"></span>
            <p>{{ error | translate }}</p>
          </li>
        </ul>
      </div>
    </ng-template>
  </div>
  <div class="flex-container central-alignment-h w-100 align-content-center flex-wrap buttons justify-content-center">
    <common-buttons-filled class="button-component w-100" *ngIf="errorType == recognitionErrors.Recognition" [label]="'buttons.tryAgain' | translate" (output)="tryAgain()"></common-buttons-filled>
    <common-buttons-outlined class="button-component w-100" [label]="'buttons.cancel' | translate" (output)="cancel()"></common-buttons-outlined>
  </div>
</section>